import * as yup from 'yup';

export const AdministrationUserCreateStep2Schema = (
  t: (key: string, options?: { [key: string]: string }) => string,
): yup.AnyObjectSchema =>
  yup.object().shape({
    email: yup
      .string()
      .required(t('errors.missing.email'))
      .max(255, t('errors.inputTooLong'))
      .email(t('errors.invalidEmail')),
  });
